
export default class MemberPurchaseBankAccountsRequestModel {
    public quantity: number = 0;
    public paymentToken: string = '';
}
